
// Hardcoded list of workouts
const workouts = {
    squat: { name: 'Squat' },
    benchPress: { name: 'Bench Press' },
    deadlift: { name: 'Deadlift' },
    overheadPress: { name: 'Overhead Press' },
    pullUp: { name: 'Pull-Up' },
  };


export default workouts;

